import { Controller, useForm } from "react-hook-form";
import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog.js";
import {
  Box,
  CircularProgress,
  debounce,
  DialogActions,
  DialogContent,
  Divider,
  FormHelperText,
  IconButton,
  InputBase,
  InputLabel,
  Paper,
  Tooltip,
} from "@mui/material";
import {
  BodyMedium,
  H6HeadlineSmall,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import {
  PrimaryButton,
  StyledIconButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  StyledFormControl,
  StyledOutlinedInput,
} from "../../../components/StyledComponents/Inputs/Inputs.js";
import { useAuth0 } from "@auth0/auth0-react";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import TagList from "../../../TagMangement/Components/TagList/TagList.js";
import { useListTagsAttachedToMiners } from "../../queries/useListTagsAttachedToMiners.ts";
import useMinerPageContext from "../../context/useMinerPageContext.js";
import SearchIcon from "@mui/icons-material/Search";
import { usePostDetachTagsFromMiners } from "../../queries/usePostDetachTagsFromMiners.ts";

const TagFormHeader = ({ setOpen }) => {
  const {
    setSelectedSerials,
    minerPageTagListSelectionTracker,
    setMinerPageTagListSelectionTracker,
  } = useMinerPageContext();
  const { colors } = useTheme();
  console.log(
    "TagFormHeader minerPageTagListSelectionTracker",
    minerPageTagListSelectionTracker
  );
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      flexGrow={1}
      padding={"1.5rem 0"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={2}
      >
        <H6HeadlineSmall>
          {"Detach tags from miners"}
        </H6HeadlineSmall>

        <BodyMedium>
          Select the tags you want to detach from the
          miners.
        </BodyMedium>
      </Box>

      <StyledIconButton   
        colors={colors}
        onClick={() => {
          setOpen(false);
          if (
            minerPageTagListSelectionTracker ===
            "compactedtaglist"
          ) {
            // Reset the selected serials when closing the dialog
            setSelectedSerials([]);
            setMinerPageTagListSelectionTracker("");
          }
        }}
      >
        <CloseIcon />
      </StyledIconButton>
    </Box>
  );
};

const TagsFromMinersList = ({
  setOpen,
  refetch: minerPageRefetch,
  open,
  userRole,
}) => {
  const [authToken, setAuthToken] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const [searchValue, setSearchValue] = useState("");
  const [dsearchValue, setDSearchValue] = useState("");
  const [tagData, setTagData] = useState([]);
  const { colors } = useTheme();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const {
    selectedSerials,
    minerPageTagListSelectionTracker,
    setMinerPageTagListSelectionTracker,
    setSelectedSerials,
  } = useMinerPageContext();

  React.useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    console.log("selectedSerials", selectedSerials);
  }, [selectedSerials]);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch: tagsDataRefetch,
    status,
    isFetched: isTagsDataFetched,
    isLoading: isTagsDataLoading,
  } = useListTagsAttachedToMiners({
    open,
    authToken,
    serialNos: selectedSerials,
    tagName: dsearchValue,
  });

  const debouncedUpdate = React.useMemo(
    () =>
      debounce((text) => {
        setDSearchValue(text); // Update the search text state
      }, 300), // 300ms debounce delay
    []
  );

  const handleSearchChange = (event) => {
    const text = event.target.value;
    console.log("Search text:", text);
    setSearchValue(text);
    debouncedUpdate(text); // Trigger the debounced function
  };

  let limit = 25;
  console.log("tagData", data);
  useEffect(() => {
    if (data && data.pages) {
      console.log(data.pages);
      const tagData =
        isTagsDataFetched && data.pages.length > 0
          ? data.pages
              .flatMap((page, pageIndex) =>
                page.msg.map((item, index) => {
                  // Generate a unique ID by combining the page index and the item index
                  return {
                    ...item,
                    id: pageIndex * limit + index,
                    isTagSelected: false,
                  };
                })
              )
              .sort((a, b) => {
                return a.tag.localeCompare(b.tag);
              })
          : [];
      setTagData((prevData) => {
        const finalData = tagData.map((item) => {
          return {
            ...item,
            isTagSelected:
              prevData.find(
                (prevItem) => prevItem.tag === item.tag
              )?.isTagSelected || false,
          };
        });
        return finalData;
      });
    }
  }, [data, isTagsDataFetched, limit]);

  const [numberOfSelections, setNumberOfSelections] =
    useState(0);

  const { mutate: detachTagsFromMiners } =
    usePostDetachTagsFromMiners();

  const handleTagDetach = async () => {
    const selectedTags = tagData.filter(
      (tag) => tag.isTagSelected
    );
    const tagNames = selectedTags.map((tag) => tag.tag);
    await detachTagsFromMiners(
      {
        minernames: selectedSerials,
        tags: tagNames,
      },
      {
        onSuccess: async (response) => {
          if (response.status === "ok") {
            setToastMessage(
              `Successfully detached ${tagNames.length} tags from miners`
            );
            setToastOpen(true);
            await minerPageRefetch();
            setOpen(false);
            if (
              minerPageTagListSelectionTracker ===
              "compactedtaglist"
            ) {
              // Reset the selected serials when closing the dialog
              setSelectedSerials([]);
              setMinerPageTagListSelectionTracker("");
            }
          } else {
            setToastMessage(
              `Failed to detach tags from miners: ${response.msg}`
            );
            setToastOpen(true);
          }
        },
        onError: (error) => {
          setToastMessage(
            `Failed to detach tags from miners: ${error}`
          );
          setToastOpen(true);
        },
      }
    );
  };

  return (
    <>
      <TagFormHeader setOpen={setOpen} />
      <Box
        display={"flex"}
        paddingTop={"1.5rem"}
        paddingBottom={"1.5rem"}
        backgroundColor={colors?.background?.secondary}
        borderRadius={"1rem"}
        flexDirection={"column"}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          paddingBottom={"1rem"}
          paddingLeft={"1rem"}
          alignItems={"center"}
        >
          <Paper
            component="form"
            elevation={0}
            sx={{
              p: "0 !important",
              display: "flex",
              alignItems: "center",
              width: "25rem",
            }}
            borderRadius={"6.25rem"}
          >
            <InputBase
              sx={{  ml: 4, flex: 1, "& .MuiInputBase-input": {
                color: colors.text.primary,             // normal text
                "::placeholder": {
                  color: colors.text.hint,
                },
              }
            }}
              placeholder="Search for tags"
              onChange={handleSearchChange}
              value={searchValue}
              inputProps={{
                "aria-label": "search for tags",
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                }
              }}
            />
            <IconButton
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
            >
              <SearchIcon sx={{ color: colors.text.muted }} />
            </IconButton>
          </Paper>
        </Box>
        <TagList
          tagList={tagData || []}
          isTagsDataLoading={isTagsDataLoading}
          isTagsDataFetched={isTagsDataFetched}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          setTagData={setTagData}
          setNumberOfSelections={setNumberOfSelections}
          attachTagsMode={false}
          detachTagsMode={true}
          maxHeight={"20rem"}
        />
      </Box>
      <Box
        pt={"1.5rem"}
        pb={"1.5rem"}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
      >
        <PrimaryButton colors={colors}
          disabled={
            tagData.every((tag) => !tag.isTagSelected) ||
            userRole === "user"
          }
          onClick={handleTagDetach}
        >
          Detach
        </PrimaryButton>
      </Box>
    </>
  );
};

const UntagMinersDialog = ({
  open,
  setOpen,
  refetch,
  userRole,
}) => {
  const {
    setSelectedSerials,
    minerPageTagListSelectionTracker,
    setMinerPageTagListSelectionTracker,
  } = useMinerPageContext();
  const { colors } = useTheme();
  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      open={open}
      // hideBackdrop
      onClose={(_, reason) => {
        if (reason === "backdropClick") {
          setOpen(false);
          if (
            minerPageTagListSelectionTracker ===
            "compactedtaglist"
          ) {
            // Reset the selected serials when closing the dialog
            setSelectedSerials([]);
            setMinerPageTagListSelectionTracker("");
          }
        }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <TagsFromMinersList
          setOpen={setOpen}
          refetch={refetch}
          open={open}
          userRole={userRole}
        />
      </DialogContent>
    </StyledDialog>
  );
};

export default UntagMinersDialog;
